<template>
  <div class="qpp-margin-sides-5pc">
    <div class="action-container">
          <input
            type="date"
            v-model="internalStartDay"
            @change="$emit('emittedDays', [internalStartDay, internalEndDay])"
            max="9999-12-31"
            pattern="\d{4}-\d{2}-\d{2}"
            class="input-layout w3-border w3-round-medium"
          />
          <input
            type="date"
            v-model="internalEndDay"
            @change="$emit('emittedDays', [internalStartDay, internalEndDay])"
            max="9999-12-31"
            pattern="\d{4}-\d{2}-\d{2}"
            class="input-layout w3-border w3-round-medium"
          />
      <div class="button-container">
        <button
          class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium"
          @click="exportPDF"
          title="PDF"
        >
          <i class="fa w3-large fa-file-pdf w3-text-red"></i>
        </button>
      </div>
    </div>
  </div>
  <slot />
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "ReportItem",
  components: {},
  props: ["fileName", "columns", "objects", "startDay", "endDay"],
  emits: ["emittedStartday", "emittedEndday", "emittedDays"],
  data() {
    return {
      internalStartDay: this.startDay,
      internalEndDay: this.endDay,
    };
  },
  computed: {},
  mounted() {},
  watch: {
    startDay(newValue) {
      this.internalStartDay = newValue;
    },
    endDay(newValue) {
      this.internalEndDay = newValue;
    },
  },
  methods: {
    exportPDF() {
      const doc = new jsPDF("landscape");
      doc.autoTable(this.columns, this.objects, {
        theme: "striped",
        headerStyles: { fillColor: [9, 78, 119] },
        styles: {
          overflow: "linebreak",
        },
      });
      doc.save(this.fileName + ".pdf");
    },
  },
};
</script>

<style scoped>

.input-layout {
  aspect-ratio: 5;
  padding: 8px;
  display:block; 
  border:none;
  border-bottom:1px solid #ccc;
  width: 100%;
  max-width: 200px;
  margin-right: 1%;
}

.button-container {
  margin-left: 20px;
}

.button-container button {
  height: 100%;
  padding-top: 0%;
  padding-bottom: 0%;
}

.action-container {
  min-width: 400px;
  width: 35%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 50px;
}

</style>
